import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
  // Estado para almacenar el valor debonceado
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Establecer un temporizador (timer) que actualiza el valor debonceado después del `delay`
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // La función de limpieza se ejecutará si `value` o `delay` cambian.
    // Esto previene que se actualice el valor debonceado si el usuario
    // sigue escribiendo.
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]); // El efecto se vuelve a ejecutar si `value` o `delay` cambian

  return debouncedValue;
}
